// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__ZkXzw","box":"WorkspacesBox_box__oYpXV","node":"WorkspacesBox_node__QnhA3"};